<template>
    <div class="secondary-btn">
        <span v-if="checkStatus" @click="hdlClick" class="toggleStatus">
            <svg class="fa fa-spinner fa-spin fa-pulse"></svg>
        </span>
        <div class="default-toggle" v-else @click="hdlClick">
            <svg class="fa fa-tasks"></svg>
        </div>
    </div>
</template>

<script>
export default {
  name: 'oButtonToggle',
  props: ['checkStatus'],
  data() {
    return {}
  },
  methods: {
    hdlClick(e) {
      this.$emit('click', e)
    },
  },
}
</script>


<style scoped>
.secondary-btn {
  height: 36.8px;
  margin-right: 4px;
  display: flex;
}
.secondary-btn span,
.default-toggle {
  color: var(--o-primary);
  font-size: 26px;
  cursor: pointer;
}
.default-toggle{
  padding: 6px 6px 3px 6px;
}
.secondary-btn span {
  padding: 5px 6px 3px 6px;
}
.secondary-btn span:hover,
.default-toggle:hover{
  background-color: var(--o-primary);
  color: var(--o-text-on-bg);   
} 
</style>